import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = '';

const avatarEstudianteSlice = createSlice({
	name: 'avatarEstudiante',
	initialState,
	reducers: {
		setAvatarEstudiante: (state, action: PayloadAction<string>) => {
			return action.payload;
		}
	}
});

export const { setAvatarEstudiante } = avatarEstudianteSlice.actions;

export default avatarEstudianteSlice.reducer;
